
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/adaptive",
      function () {
        return require("private-next-pages/rollers/adaptive/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/adaptive"])
      });
    }
  